import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import ConversationEffect from "src/Animations/ConversationEffect";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_AI_POWERED_DOC_INLCM_1 = {
  title: "User can select the type of document \nto be generated.",
  subtitle: "Gen AI powered network design",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_308"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_1.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_ai_powered_01_computer.png",
          imageStyle: { position: "absolute", bottom: "170px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_ai_powered_01_screen.png",
          imageStyle: { position: "absolute", bottom: "236px", right: "63px" },
        },
        {
          image: "ENG/INLCM/INLCM_ai_powered_01_network.png",
          imageStyle: { position: "absolute", bottom: "71px", right: "193px" },
        },
      ]}
      pageNumber={"ENG_307"}
    />
  ),
};
